import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import authApi from '@/api/auth'
import VueCookies from 'vue-cookies'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    authUser: null,
    accessToken: null,
    isLockScreen: false,
    languages: {
      en: 1,
      kh: 2
    }
  },
  getters: {
    authenticated: state => state.accessToken !== null,
    accessToken: state => state.accessToken,
    permissionAllowCode: state =>
      state.authUser !== null ? state.authUser.permission_allow_code : null,
    permissions: state =>
      state.authUser !== null ? state.authUser.permissions : null,
    limitStringShow: state => text => {
      if (text != null) {
        let article = text.replace(/(<([^>]+)>)/gi, '')
        return article.length > 60 ? article.substring(0, 60) + '...' : article
      }
      return ''
    },
    formatNumber: state => (value = "", currency_id = 2) => {
      // let decimal = state.authUser.sys_setting.decimal_digit;
      let decimal = 2;
      if (value) {
          let decimalDigit = (value / 1)
              .toFixed(decimal)
              .replace(",", ".");
          let val = value
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          if (currency_id == 2) {
              if (
                  decimalDigit.substring(decimalDigit.indexOf(".") + 1) ==
                  0
              ) {
                  return val;
              }
              return (
                  val.split(".")[0] +
                  decimalDigit.substring(decimalDigit.indexOf("."))
              );
          }
          if (value.toString().indexOf(".") >= 0) {
              // input value with decimal
              return (
                  val.split(".")[0] +
                  decimalDigit.substring(decimalDigit.indexOf("."))
              );
          }
          return val + decimalDigit.substring(decimalDigit.indexOf("."));
      }
      return "-";
    },
    formatCurrencyWithCode: (state, getters) => (value, currency) => {
        if (state) {
            //
        }
        if (!currency) {
            if (value) {
                return value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return "-";
        }
        return (
            getters.formatNumber(value, currency.currency_id) +
            " " +
            currency.currency_code
        );
    },
    formatCurrencyWithSign: (state, getters) => (value, currency) => {
        if (!currency) {
            if (value) {
                return value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return "-";
        }
        if (state) {
            //
        }
        return (
            getters.formatNumber(value, currency.currency_id) +
            " " +
            currency.currency_sign
        );
    },
    signBycurrencyId: state => currency_id => {
        if (currency_id == 1) {
            //usd
            return "$";
        }
        if (currency_id == 2) {
            //khr
            return "៛";
        }
        if (currency_id == 3) {
            //bath
            return "B";
        }
        if (state) {
            //
        }
    }
  },
  mutations: {
    setAuthUser(state, authUser) {
      if (authUser) {
        state.authUser = Object.assign(
          {},
          {
            user: authUser.user,
            permission_allow_code: authUser.permission_allow_code,
            permissions: authUser.permissions,
            counter: authUser.counter,
            sys_setting: authUser.sys_setting
          }
        )

        localStorage.setItem('authUser', JSON.stringify(state.authUser))
      } else {
        state.authUser = null
        localStorage.clear()
      }
      state.accessToken = VueCookies.get('token')
    },
    setIsLock(state, value) {
      state.isLockScreen = value
      localStorage.setItem('!z_dy#@_____00111$%!@', value)
    }
  },
  actions: {
    init({ state, commit }) {
      const authUser = JSON.parse(localStorage.getItem('authUser'))
      if (authUser) {
        commit('setAuthUser', authUser)
      }
      commit(
        'setIsLock',
        parseInt(localStorage.getItem('!z_dy#@_____00111$%!@'))
      )
    },
    login({ commit }, formData) {
      return authApi.login(formData).then(response => {
        VueCookies.set('token', response.data.access_token, 'Session').set(
          'refresh_token',
          response.data.refresh_token,
          'Session'
        )
        commit('setAuthUser', response.data)
        commit('setIsLock', false)
        return Promise.resolve(response)
      })
    },
    logout({ commit }) {
      VueCookies.remove('token')
      VueCookies.remove('refresh_token')
      commit('setAuthUser', null)
      commit('setIsLock', false)
    },
    companryLogo({ commit }) {
      return authApi.companryLogo().then(response => {
        return Promise.resolve(response)
      })
    }
  },
  modules
})

store.dispatch('init')

export default store
